import React from 'react';
import { Helmet } from 'react-helmet-async';
import Workflows from '../common/workflow/Workflows';

function AdminWorkflowsView() {
  return (
    <>
      <Helmet>
        <title>BVT Admin - Workflows</title>
      </Helmet>
      <Workflows />
    </>
  );
}

export default AdminWorkflowsView; 